import { cliente } from '@/lib/cliente';
import type { PeriodoMaqSel } from '@/lib/cliente';
import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

/** Unidades de Producción + cifras por máquina. Período propio de Maquinaria opcional. */
export function useUnidadesProduccion(periodoMaq?: PeriodoMaqSel) {
  return useQuery({
    queryKey: ['unidades-produccion', periodoMaq],
    queryFn: () => cliente.unidades.analisis(periodoMaq),
    placeholderData: keepPreviousData,
  });
}

/** Mutaciones de administración de unidades; refrescan el análisis al terminar. */
export function useUnidadesProduccionMutaciones() {
  const qc = useQueryClient();
  const refrescar = () => qc.invalidateQueries({ queryKey: ['unidades-produccion'] });

  const crear = useMutation({
    mutationFn: (v: { nombre: string; descripcion?: string | null }) => cliente.unidades.crear(v),
    onSuccess: refrescar,
  });
  const editar = useMutation({
    mutationFn: (v: { id: number; nombre: string; descripcion?: string | null }) =>
      cliente.unidades.editar(v.id, { nombre: v.nombre, descripcion: v.descripcion }),
    onSuccess: refrescar,
  });
  const borrar = useMutation({
    mutationFn: (id: number) => cliente.unidades.borrar(id),
    onSuccess: refrescar,
  });
  const asignar = useMutation({
    mutationFn: (v: { codigosMaquina: string[]; skUnidadProduccion: number | null }) =>
      cliente.unidades.asignar(v.codigosMaquina, v.skUnidadProduccion),
    onSuccess: refrescar,
  });

  return { crear, editar, borrar, asignar };
}
